// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"149":"8cd928ae88cad450","191":"e6e780f9edf47873","244":"ff35acff4471840b","245":"35e093e6dffa359a","451":"82385130f21f7e79","453":"1dbc8082595e54ac","569":"41e44d2b577b8cb2","664":"c8c2bc2dbddbef7f","710":"aebe55307998fbb0","714":"2e2685b3669c737a"}[chunkId] + ".js";
};